<!-- @veltra/icons generated sha256:026d8a99c0407e1f gen:8 source:src/svg/normal/secured.svg -->
<script setup lang="ts">
defineOptions({ name: 'Secured' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2.5 9V2.987C2.5 2.435 2.963 2 3.515 2h8.97c.552 0 1.015.435 1.015.987V9a4.03 4.03 0 0 1-1.958 3.458L8 14.583l-3.542-2.125A4.03 4.03 0 0 1 2.5 9m1-6v6c0 1.065.559 2.052 1.472 2.6L8 13.417l3.028-1.817A3.03 3.03 0 0 0 12.5 9V3zm7.11 3.709-3.22 3.22-2.003-2.003a.5.5 0 0 1 .005-.707L5.4 7.21a.49.49 0 0 1 .698.013l1.291 1.29L9.9 6.007a.494.494 0 0 1 .701-.016l.021.02a.49.49 0 0 1-.011.699"
    />
  </svg>
</template>
